import { render, staticRenderFns } from "./train-add.vue?vue&type=template&id=78456f86&scoped=true"
import script from "./train-add.vue?vue&type=script&lang=js"
export * from "./train-add.vue?vue&type=script&lang=js"
import style0 from "./train-add.vue?vue&type=style&index=0&id=78456f86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78456f86",
  null
  
)

export default component.exports